import request from '@/utils/request'
// 投票活动管理
const url = '/api/learn.Index/'
/**
 * 活动信息
 * @param {array} params 请求参数
 */
export function reqLearnInfo(params) {
  return request({
    url: url + 'info',
    method: 'get',
    params: params
  })
}

/**
 * 活动扩展信息
 * @param {array} params 请求参数
 */
export function reqLearnExtend(params) {
  return request({
    url: url + 'extend',
    method: 'get',
    params: params
  })
}

/**
 * 分组列表
 * @param {array} params 请求参数
 */
export function reqGroups(params) {
  return request({
    url: url + 'groups',
    method: 'get',
    params: params
  })
}

/**
 * 课程列表
 * @param {array} params 请求参数
 */
export function reqLessions(params) {
  return request({
    url: url + 'lessions',
    method: 'get',
    params: params
  })
}

/**
 * 课程详情
 * @param {array} params 请求参数
 */
export function reqLessionsInfo(params) {
  return request({
    url: url + 'show',
    method: 'get',
    params: params
  })
}

/**
 * 用户详情
 * @param {array} params 请求参数
 */
export function reqUserInfo(params) {
  return request({
    url: url + 'userinfo',
    method: 'get',
    params: params
  })
}

/**
 * 用户登记
 * @param {array} params 请求参数
 */
export function reqIsReg(params) {
  return request({
    url: url + 'isreg',
    method: 'get',
    params: params
  })
}

/**
 * 用户登记
 * @param {array} params 请求参数
 */
export function reqUserAdd(params) {
  return request({
    url: url + 'add',
    method: 'get',
    params: params
  })
}


/**
 * 参与建档（幂等）：公开活动「开始学习」时调用
 * @param {array} params 请求参数
 */
export function reqJoin(params) {
  return request({
    url: url + 'join',
    method: 'get',
    params: params
  })
}

/**
 * 用户登录（账号口令/短信验证/统一口令/多口令）
 * @param {array} params 请求参数
 */
export function reqLogin(params) {
  return request({
    url: url + 'login',
    method: 'get',
    params: params
  })
}

/**
 * 发送短信验证码
 * @param {array} params 请求参数
 */
export function reqSendCode(params) {
  return request({
    url: url + 'sendCode',
    method: 'get',
    params: params
  })
}


/**
 * 用户修改
 * @param {array} params 请求参数
 */
export function reqUserEdit(params) {
  return request({
    url: url + 'edit',
    method: 'get',
    params: params
  })
}


/**
 * 观看开始线
 * @param {array} params 请求参数
 */
export function reqWatchTime(params) {
  return request({
    url: url + 'watchTime',
    method: 'get',
    params: params
  })
}

/**
 * 增加学习分值
 * @param {array} params 请求参数
 */
export function reqAddScore(params) {
  return request({
    url: url + 'addScore',
    method: 'get',
    params: params
  })
}


/**
 * 查询用户是否进行指定课程的答题
 * @param {array} params 请求参数
 */
export function reqIsAnswer(params) {
  return request({
    url: url + 'isAnswer',
    method: 'get',
    params: params
  })
}

/**
 * 提交课程答题
 * @param {array} params 请求参数
 */
export function reqSubAnswer(params) {
  return request({
    url: url + 'subAnswer',
    method: 'get',
    params: params
  })
}

/**
 * 获取更新证书
 * @param {array} params 请求参数
 */
export function reqSncode(params) {
  return request({
    url: url + 'updateSncode',
    method: 'get',
    params: params
  })
}

/**
 * 地区联动菜单数据（树形，供 cascader 使用）
 * @param {array} params 请求参数 { platform, learnid, region_id? }
 */
export function reqRegion(params) {
  return request({
    url: url + 'region',
    method: 'get',
    params: params
  })
}

/**
 * 分组排名（按自定义表单字段分组，组内按学习积分降序）
 * @param {array} params 请求参数 { platform, learnid, field_name, value_key?, top? }
 */
export function reqRank(params) {
  return request({
    url: url + 'rank',
    method: 'get',
    params: params
  })
}

/**
 * 访问量埋点
 * @param {array} params 请求参数 { learnid, platform }
 */
export function reqStat(params) {
  return request({
    url: '/api/learn.Stat/visit',
    method: 'get',
    params: params
  })
}